import React from 'react';
import styled from 'styled-components';

const MIN_WIDTH_PERCENT = 6; // ensure small segments remain visible

const QuestionDistributionChart = ({ data, legend }) => {
    if (!data || data.length === 0) return null;

    const percentages = data.map((d) => d.data?.[0] ?? 0);
    const adjusted = adjust(percentages);

    return (
        <Outer>
            {legend && <LegendWrap>{legend}</LegendWrap>}
            <BarWrap>
                {data.map((item, idx) => (
                    <Segment key={idx} width={adjusted[idx]} color={item.color} title={`${item.count ?? 0} responses`}>
                        <Pct>{Math.round(item.data?.[0] ?? 0)}%</Pct>
                    </Segment>
                ))}
            </BarWrap>
        </Outer>
    );
};

export default QuestionDistributionChart;

function adjust(values) {
    const mins = values.map((v) => (v < MIN_WIDTH_PERCENT ? MIN_WIDTH_PERCENT : v));
    const delta = values.reduce((s, v) => s + (v < MIN_WIDTH_PERCENT ? MIN_WIDTH_PERCENT - v : 0), 0);
    const largeSum = values.reduce((s, v) => s + (v >= MIN_WIDTH_PERCENT ? v : 0), 0);
    return values.map((v) => {
        if (v >= MIN_WIDTH_PERCENT) {
            return largeSum > 0 ? (v / largeSum) * (largeSum - delta) : v;
        }
        return MIN_WIDTH_PERCENT;
    });
}

const Outer = styled.div`
    width: 100%;
`;

const LegendWrap = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 8px;
`;

const BarWrap = styled.div`
    display: flex;
    gap: 2px;
    height: 28px;
    background: #f9fafb;
    border-radius: 8px;
    padding: 4px;
`;

const Segment = styled.div`
    width: ${(p) => p.width}%;
    background: ${(p) => p.color};
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 700;
    font-size: 12px;
`;

const Pct = styled.span``;

